import React from "react";
import PortalModal from "../../../../Components/PortalModal";

export default function ConfirmationModal({
  show,
  onClose,
  onConfirm,
  title,
  message,
  price,
}) {
  if (!show) return null;

  return (
    <PortalModal>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
          <h3 className="text-lg font-semibold mb-4 text-gray-800">
            {title || "Confirm Payment"}
          </h3>
          <div className="mb-6">
            <p className="text-sm text-gray-600 mb-4">{message}</p>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium text-gray-700">
                  Amount to be deducted:
                </span>
                <span className="text-2xl font-bold text-blue-600">
                  ₹{price}
                </span>
              </div>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row justify-end gap-3">
            <button
              onClick={onClose}
              className="w-full sm:w-auto px-6 py-2 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="w-full sm:w-auto px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Confirm & Pay
            </button>
          </div>
        </div>
      </div>
    </PortalModal>
  );
}
